import type { TourStepData } from './types';

export const contentFactoryTourSteps: TourStepData[] = [
  {
    target: '[data-tour="content-factory-header"]',
    title: 'Content Factory',
    content:
      'La Content Factory (Usine a contenu) genere automatiquement des contenus marketing via l\'IA : posts LinkedIn, emails de prospection et threads Twitter.',
    placement: 'bottom',
    glossaryTerm: 'content-factory',
  },
  {
    target: '.grid.grid-cols-1.sm\\:grid-cols-2.lg\\:grid-cols-4',
    title: 'Statistiques de generation',
    content:
      'Suivez en temps reel le nombre de contenus generes, les tokens IA consommes et la repartition par format.',
    placement: 'bottom',
    glossaryTerm: 'token',
  },
  {
    target: '.fc-card',
    title: 'Formulaire de generation',
    content:
      'Saisissez votre sujet, selectionnez un persona et ajoutez du contexte. L\'IA genere simultanement 3 formats de contenu.',
    placement: 'top',
  },
];
